import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { MAX_LINE_ITEM_QUANTITY } from '../../utils/constants';
import { assertNever } from '../../utils/common';
import { LineItemConversionError } from './types/validation';
import { jsx as _jsx } from "react/jsx-runtime";
export function LineItemValidationMessages({
  lineItemConversionErrors
}) {
  return [...lineItemConversionErrors.values()].map(errorMessage => {
    switch (errorMessage) {
      case LineItemConversionError.LARGE_QUANTITY:
        return /*#__PURE__*/_jsx("span", {
          "data-test-id": `convert-validation-tooltip:${errorMessage}`,
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "subscriptions.ConvertToSubscription.validationMessages.reasons.quantityMax_jsx",
            elements: {
              FormattedNumber
            },
            options: {
              numberProps: {
                value: MAX_LINE_ITEM_QUANTITY
              }
            }
          })
        }, errorMessage);
      case LineItemConversionError.RELATIVE_START_DATE:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": `convert-validation-tooltip:${errorMessage}`,
          message: "subscriptions.ConvertToSubscription.validationMessages.reasons.relativeStartDate"
        }, errorMessage);
      case LineItemConversionError.FUTURE_ONE_TIME_LINE_ITEM:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": `convert-validation-tooltip:${errorMessage}`,
          message: "subscriptions.ConvertToSubscription.validationMessages.reasons.futureStartDateOneTime"
        }, errorMessage);
      case LineItemConversionError.PAST_START_DATE:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": `convert-validation-tooltip:${errorMessage}`,
          message: "subscriptions.ConvertToSubscription.validationMessages.reasons.pastStartDate"
        }, errorMessage);
      case LineItemConversionError.UNSUPPORTED_CURRENCY:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": `convert-validation-tooltip:${errorMessage}`,
          message: "subscriptions.ConvertToSubscription.validationMessages.reasons.unsupportedCurrency"
        }, errorMessage);
      case LineItemConversionError.MULTIPLE_CURRENCIES:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": `convert-validation-tooltip:${errorMessage}`,
          message: "subscriptions.ConvertToSubscription.validationMessages.reasons.multipleCurrencies"
        }, errorMessage);
      case LineItemConversionError.FRACTIONAL_QUANTITY:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": `convert-validation-tooltip:${errorMessage}`,
          message: "subscriptions.ConvertToSubscription.validationMessages.reasons.fractionalQuantity"
        }, errorMessage);
      default:
        assertNever(errorMessage, 'LineItemConversionError');
        return null;
    }
  });
}